module.exports = __webpack_public_path__ + "img/4-1.08ff50e4.svg";